import { useState, useEffect } from "react";
import classes from './MattiasAgeTracker.module.css';

const MattiasAgeTracker  = () => {
    const [age, setAge] = useState({ years: 0, months: 0, days: 0 });

    useEffect(() => {
      const calculateAge = () => {
        const birthDate = new Date(2025, 0, 10); // 10 January 2025
        const currentDate = new Date();
  
        let years = currentDate.getFullYear() - birthDate.getFullYear();
        let months = currentDate.getMonth() - birthDate.getMonth();
        let days = currentDate.getDate() - birthDate.getDate();
  
        if (days < 0) {
          months -= 1;
          days += new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            0
          ).getDate();
        }
  
        if (months < 0) {
          years -= 1;
          months += 12;
        }
  
        setAge({ years, months, days });
      };
  
      calculateAge();
      const interval = setInterval(calculateAge, 86400000); // Daily update
  
      return () => clearInterval(interval);
    }, []);
  
    return (
      <div className={classes.container}>
        <h1 className={classes.title}>🌟 Mattias' Journey 🌟</h1>
        <div className={classes.subtitle}>Born January 10, 2025 🎈</div>
  
        <div className={classes.ageContainer}>
          <div className={classes.ageCard}>
            <div className={classes.number}>{age.years}</div>
            <div className={classes.label}>Years 🎂</div>
          </div>
  
          <div className={classes.ageCard}>
            <div className={classes.number}>{age.months}</div>
            <div className={classes.label}>Months 📅</div>
          </div>
  
          <div className={classes.ageCard}>
            <div className={classes.number}>{age.days}</div>
            <div className={classes.label}>Days 🌞</div>
          </div>
        </div>
  

      </div>
    );
}

export default MattiasAgeTracker 